<template>
    <div :class="['input-wrapper', 'form-input-email', { 'input-has-full-border': fullBorder, 'input-wrapper-mb-2x': marginBottomDouble, 'is-required': required }]">
        <label v-if="label" :for="name" :class="{ 'float-label-active': isFloatLabelActive, 'is-float-label': !withoutFloatLabel }">{{ label }}<span v-if="required">*</span></label>
        <input
            :id="name"
            :class="{ 'input-error-border': hasError, 'full-border': fullBorder, 'basic-border': !fullBorder }"
            type="email"
            :placeholder="placeholder ? placeholder : label"
            :name="name"
            v-model="inputValue"
            :required="required"
            :disabled="disabled"
            @focus="activateFloatLabel"
            @blur="deactivateFloatLabel"
        />

        <form-input-error v-if="hasError" :error="errors[0]"></form-input-error>
        <form-input-note v-else-if="note" :text="note"></form-input-note>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Array,
                required: false,
                default: null
            },

            name: {
                type: String,
                required: true
            },

            label: {
                type: String,
                required: false,
                default: null
            },

            placeholder: {
                type: String,
                required: false,
                default: ''
            },

            required: {
                type: Boolean,
                required: false,
                default: false
            },

            fullBorder: {
                type: Boolean,
                required: false,
                default: false
            },

            note: {
                type: String,
                required: false,
                default: null
            },
            
            value: {
                type: String,
                required: false,
                default: ''
            },

            marginBottomDouble: {
                type: Boolean,
                required: false,
                default: false
            },

            disabled: {
                type: Boolean,
                required: false,
                default: false
            },

            withoutFloatLabel: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data() {
            return {
                inputValue: this.value,
                hasError: false,
                isFloatLabelActive: false
            }
        },

        watch: {
            inputValue: {
                immediate: true,
                handler(value) {
                    if (value.length > 0) {
                        this.hasError = false
                        this.isFloatLabelActive = true
                    }
                }
            },

            errors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                    } 
                }
            }
        },

        methods: {
            activateFloatLabel() {
                this.isFloatLabelActive = true
            },

            deactivateFloatLabel() {
                if(this.inputValue.length === 0) {
                    this.isFloatLabelActive = false
                }
            }
        }
    }
</script>
